export const iconFontAwesomeMoneyMoneyBills = (
	<i className="fa-solid fa-money-bills"></i>
);
